import { useUIVersion } from "#hooks";
import { CheckboxIcon } from "#icons";

import { boxStyles } from "./Checkbox.styles";

export interface CheckboxIndicatorProps {
  isSelected: boolean;
  isHovered: boolean;
  isFocused: boolean;
}

export function CheckboxIndicator({ isSelected, isHovered, isFocused }: CheckboxIndicatorProps) {
  const uiVersion = useUIVersion();

  return (
    <div className={boxStyles({ isSelected, uiVersion, isHovered, isFocused })}>
      {isSelected ? <CheckboxIcon className="text-neutral-white" size={8} /> : null}
    </div>
  );
}
